import _ from 'lodash';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { selectDeletedOptionList } from 'app/campaign/features/option.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-deleted-option-list',
  templateUrl: './campaign-deleted-option-list.component.html',
  styleUrl: './campaign-deleted-option-list.component.scss',
})
export class CampaignDeletedOptionListComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public list: any = [];
  public filteredList: any = [];
  public search: UntypedFormControl = new UntypedFormControl('', []);
  
  public deletedOptionList$ = this.store.pipe(
    select(selectDeletedOptionList)
  );

  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.deletedOptionList$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(list => {
      this.list = list;
      this.filteredList = this.list;
    });

    this.search.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(searchQuery => {
      this.filteredList = _.filter(this.list, ({data: option}: any) => {
        return option.name.toLowerCase().includes(searchQuery.toLowerCase())
      });
    });
  }

  resetSearch() {
    this.search.setValue('');
  }
}
